import { render, staticRenderFns } from "./ChooseCar.vue?vue&type=template&id=67cbcb60&"
import script from "./ChooseCar.vue?vue&type=script&lang=js&"
export * from "./ChooseCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports